import { RagStatus, SupplyBalanceType } from "../../ServerTypes/Modules";
import * as L from 'wwwroot/lib/leaflet/';
import { MapCenterDefault, MapZoomDefault, companyData, initMapLayers, wrzPath, AddWhereAmIButton, MapDisplayHelpInformation, companyPath } from '../../Common/Helpers/MapHelper';
import { getLookup, getjQuery, resolveUrl, tryFirst } from "@serenity-is/corelib";
import { GetInTouchLogDialog } from "../GetInTouchLog/GetInTouchLogDialog";
import { ResourceZonesRow, ResourceZonesService, SupplyBalanceRow } from "../../ServerTypes/MarketInformation";
import { OrganisationRow, OrganisationService } from "../../ServerTypes/Core";
import { MarketInformationInfoDialog } from "../../Common/Information/MarketInformation/MarketInformationInfoDialog";
import { UsageStatsService } from "../../ServerTypes/MarketInformation";
import { MarketInformationDisclaimerDialog } from "../../Common/Information/MarketInformation/MarketInformationDisclaimerDialog";
import { UsageStats } from "../../ServerTypes/Modules/Common.Enums.UsageStats";

declare var Chart;

export class MapLogic {
    private chartObject: any;
    retainGraphData: any;

    private featureStyle(props) {
        let $ = getjQuery();
        return $.extend({
            weight: 1,
            opacity: 1,
            color: 'DarkSlateGrey',
            dashArray: '4',
        }, props);
    }

    private map: L.Map;
    private infoBox = new L.Control();
    private layerControl = new L.Control.Layers();
    private currentResourceZone;
    private wrzLayer = L.layerGroup();
    private companyLayer = L.layerGroup();
    private ragColour = {};
    private selectedShape;
    private wrzRagStatus: { [wrzCode: string]: string } = {};
    private wrzData: ResourceZonesRow[];
    private organisationData: OrganisationRow[];
    
    constructor() {
        this.ragColour[RagStatus[RagStatus.High]] = 'red';
        this.ragColour[RagStatus[RagStatus.Medium]] = 'orange';
        this.ragColour[RagStatus[RagStatus.Low]] = 'green';
        this.ragColour[RagStatus[RagStatus.Ok]] = 'DeepSkyBlue';
    }

    public DisplayMarketInformation(): any {
        this.map = L.map('map').setView(MapCenterDefault, MapZoomDefault);
        (window as any).watersourceMarketInfoMap = this.map;
        this.createInfoBox();
        this.createKeyBox();

        let $ = getjQuery();

        AddWhereAmIButton(this.map);
        MapDisplayHelpInformation(this.map, { position: 'topright' });
        $(".pageInformation").click(() => {
            let dlg = new MarketInformationInfoDialog({});
            dlg.dialogOpen();
        });

        this.layerControl = initMapLayers(this.map, null, true, 'Outdoors');
        this.layerControl.addOverlay(this.companyLayer, "Water Companies");
        this.companyLayer.addTo(this.map);
        this.layerControl.addOverlay(this.wrzLayer, "Resource Zones");
        this.wrzLayer.addTo(this.map);

        OrganisationService.ListMarketInformation({
            IncludeColumns: ['Name', 'Logo']
        },
            response => {
                this.organisationData = response.Entities
            })
            .then(() => {
                this.getCompanyBorders();
            });

        ResourceZonesService.ListMarketInformation({ IncludeColumns: ['RagStatus', 'SupplyBalance', 'Annotation'] },
            response => {
                this.wrzData = response.Entities;
                this.wrzData.forEach(x => { this.wrzRagStatus[x.WrzAreaShortName] = x.RagStatus });
            });

        var marketInfoDisclaimerCookie = this.getCookieInformation(false);
        if (!marketInfoDisclaimerCookie) {
            new  MarketInformationDisclaimerDialog().dialogOpen();
        }

        UsageStatsService.LogStat({ Type: UsageStats.PageHit, SubType: "Map" });
    }

    private getCookieInformation(intergratedPage: boolean): boolean {
        if (intergratedPage) return true;
        if (document.cookie.length > 0) {
            return (document.cookie.match('(MarketInformationDisclaimer)') != null);
        }
        return false;
    }

    private createInfoBox() {
        let $ = getjQuery();
        var customControl = L.Control.extend({
            options: { position: 'bottomleft' },
            onAdd: map => {
                var container = L.DomUtil.create('div', 'info hidden');
                $(container).html(`
                        <i class='pull-right fa fa-close' id='close-graph-btn'></i>
                        <h3 id='graph-title'></h3>
                        <ul class="graph-selection nav nav-pills">
                        <li id="supply-balance-dry" class="dry balance-type active"><a href="#">Dry Year Annual Average (DYAA)</a></li>
                        <li id="supply-balance-critical" class="critical balance-type"><a href="#">Dry Year Critical Period (DYCP)</a></li>
                        </ul>
                        <div class='supply-balance-chart-container' style="height: 250px; width: 450px; margin: 0 auto;">
                            <canvas id='supply-balance-chart'></canvas>
                        </div>
                        <div id='graph-legend'>
                            <div class="color-box" style="background-color: #9fdfbf;margin-right: -3px;"></div> 
                            <div class="color-box" style="background-color: #ff3300;"></div> Do Nothing
                            <div class="color-box" style="background-color: #809fff;"></div> WRMP Impact
                        </div>
                        <div><button id="getInTouch" class="btn btn-primary btn-sm">Get in Touch</button></div>
                    `);

                return container;
            }
        });
        this.infoBox = new customControl();
        this.map.addControl(this.infoBox);

        $("#getInTouch").click(() => {
            if (!this.currentResourceZone) return;
            let dlg = new GetInTouchLogDialog(this.currentResourceZone);
            dlg.loadNewAndOpenDialog();
        })
        $("#close-graph-btn").click(() => this.hideGraph());
        $(".balance-type").click((e) => {
            $(".balance-type").removeClass("active");
            $(e.currentTarget).addClass("active");
            this.drawGraph(this.currentResourceZone.SupplyBalance, (e.currentTarget.classList.contains("critical"))
                ? SupplyBalanceType.CriticalPeriod
                : SupplyBalanceType.DryAverage);
        })
    }

    private highlightFeature = (e) => {
        var layer = e.target;
        if (this.isSelected(layer)) return;

        var highlightStyle = { weight: 3, color: '#666', dashArray: '', fillOpacity: 0.5 };
        if (layer.highlightColor) {
            highlightStyle['fillColor'] = layer.highlightColor;
        }
        layer.setStyle(highlightStyle);
    }

    private hideGraph() {
        let $ = getjQuery();
        var infoDiv = this.infoBox.getContainer();
        $(infoDiv).addClass('hidden');
    }

    private isSelected(layer: any) {
        if (!this.selectedShape) return false;
        return (layer['_leaflet_id'] == this.selectedShape['_leaflet_id']);
    }

    private zoomToFeature(e) {
        this.map.fitBounds(e.target.getBounds());
    }

    private drawGraph(supplyData: SupplyBalanceRow[], balanceType: SupplyBalanceType = SupplyBalanceType.DryAverage) {
        const $ = getjQuery();
        const colours = { green: '#9fdfbf', red: '#ff3300', blue: '#809fff' };

        const showButtons = supplyData.some(x => x.SupplyBalanceType === SupplyBalanceType[SupplyBalanceType.CriticalPeriod]);
        $(".graph-selection").toggleClass("hidden", !showButtons);

        supplyData = supplyData
            .filter(x => x.SupplyBalanceType === SupplyBalanceType[balanceType])
            .sort((a, b) => a.PeriodStart - b.PeriodStart);

        const data = supplyData.map(x => ({
            y: x.PeriodStart.toString(),
            item1: x.Baseline,
            final: x.Final
        }));

        const datasets = [
            this.createDataset(data, 'item1', colours.green, colours.red),
            this.createDataset(data, 'final', colours.blue)
        ];

        // Destroy existing chart if found
        this.chartObject?.destroy();

        // Create the new chart
        this.chartObject = new Chart('supply-balance-chart', {
            type: 'line',
            data: { labels: data.map(x => x.y), datasets },
            options: this.getChartOptions(colours.red)
        });

        this.retainGraphData = data;
    }

    private createDataset(data: any[], key: string, defaultColor: string, conditionalColor?: string) {
        return {
            data: data.map(x => x[key] ?? 0),
            borderColor: defaultColor,
            pointBackgroundColor: (ctx) => {
                const value = data[ctx.dataIndex]?.[key];
                return value < 0 ? conditionalColor ?? defaultColor : defaultColor;
            },
            pointBorderColor: (ctx) => {
                const value = data[ctx.dataIndex]?.[key];
                return value < 0 ? conditionalColor ?? defaultColor : defaultColor;
            },
            pointBorderWidth: 2,
            borderWidth: 2,
            segment: conditionalColor
                ? {
                    borderColor: (ctx) => {
                        const prev = data[ctx.p0DataIndex]?.[key] ?? 0;
                        const next = data[ctx.p1DataIndex]?.[key] ?? 0;

                        if ((prev < 0 && next >= 0) || (prev >= 0 && next < 0)) {
                            return '#9fdfbf';
                        }
                        return prev < 0 || next < 0 ? conditionalColor : defaultColor;
                    }
                }
                : undefined,
            fill: false,
            tension: 0.4
        };
    }

    private getChartOptions(redLineColor: string) {
        return {
            plugins: {
                legend: { display: false },
                tooltip: {
                    enabled: true,
                    callbacks: {
                        title: (tooltipItems) => {
                            return `Year: ${tooltipItems[0].label}`;
                        },
                        label: (tooltipItem) => {
                            const row = this.retainGraphData.find(x => x.y === tooltipItem.label);
                            if (!row) return '';

                            if (tooltipItem.datasetIndex === 0) {
                                return `Do Nothing: ${Number(row['item1']).toFixed(2)} Ml/d`;
                            } else if (tooltipItem.datasetIndex === 1) {
                                return `WRMP: ${Number(row['final']).toFixed(2)} Ml/d`;
                            }
                        }
                    },
                    displayColors: true,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    borderColor: '#ff3300',
                    borderWidth: 1,
                    titleColor: '#ffffff',
                    bodyColor: '#ffffff',
                    padding: 10
                },
                annotation: {
                    annotations: {
                        line: {
                            type: 'line',
                            yMin: 0,
                            yMax: 0,
                            borderWidth: 2,
                            borderColor: redLineColor,
                            opacity: 0.8
                        }
                    }
                }
            },
            interaction: {
                mode: 'index',
                intersect: false
            },
            responsive: true,
            scales: {
                x: { display: true },
                y: { display: true }
            },
            elements: {
                point: {
                    radius: 6,
                    hoverRadius: 8,
                    borderWidth: 2
                },
                line: {
                    tension: 0.4
                }
            }
        };
    }

    private createKeyBox() {
        let $ = getjQuery();
        var customControl = L.Control.extend({
            options: { position: 'bottomright' },
            onAdd: map => {
                var container = L.DomUtil.create('div', 'info key');
                $(container).html(`
                    <h5>Status Key</h5>
                    <div class="color-box" style="background-color: ${this.ragColour[RagStatus[RagStatus.High]]};"></div>
                        High, deficit forecast of over 10% <br/>
	                <div class="color-box" style="background-color: ${this.ragColour[RagStatus[RagStatus.Medium]]};"></div> 
                        Medium, deficit forecast of between 5% and 10%<br/>
                    <div class="color-box" style="background-color: ${this.ragColour[RagStatus[RagStatus.Low]]};"></div> 
                        Low, deficit forecast of less than 5%<br/>
                    <div class="color-box" style="background-color: ${this.ragColour[RagStatus[RagStatus.Ok]]};"></div> 
                        OK, no deficit forecast
                    `);
                return container;
            }
        });

        this.map.addControl(new customControl());
    }

    private getCompanyBorders() {

        companyData
            .forEach(company => {
                company.companyShapesJson.forEach(shape => {
                    this.addCompany(
                        shape,
                        company,
                        this.companyLayer,
                        this.featureStyle({ fillColor: company.colour || 'pink', fillOpacity: 0.2, weight: 1 })

                    );
                })
            });
    }

    private addCompany(shape, company, layergroup, style) {
        let $ = getjQuery();
        $.getJSON(companyPath(shape), data => {
            let layer = L.geoJSON(data, {
                style: style,
                onEachFeature: (feature, layer) => {
                    layer.bindTooltip(this.updateCompanyToolTipWithLogo(company),
                        { permanent: false, opacity: 0.7, sticky: true })
                    layer.on({
                        mouseover: this.highlightFeature,
                        mouseout: (e) => {
                            var layer = e.target;
                            layer.setStyle(style);

                        },
                        click: (e) => {
                            this.zoomToFeature(e);
                            this.loadWRZForCompany(company)
                            this.hideGraph();
                            UsageStatsService.LogStat({ Type: UsageStats.WaterCompany, SubType: company.name });
                        }
                    });
                }
            });
            layergroup.addLayer(layer);
        });
    }

    private updateCompanyToolTipWithLogo(company) {
        var organisation = tryFirst(this.organisationData, x => x.Name == company.name);
        var toolTip = '<h5>' + company.name + '</h5>';
        if (!organisation) {
            return toolTip;
        }
        if (!organisation.Logo) {
            return toolTip;
        }
        return '<img src="' + resolveUrl('~/upload/' + organisation.Logo) + '" alt="' + company.name + '" width="170"></img>';
    }

    private loadWRZForCompany(company) {
        this.wrzLayer.clearLayers();

        company.wrzList.forEach(wrz => {
            this.addWrz(company.name, wrzPath(company, wrz),
                this.wrzLayer,
                this.featureStyle({ fillOpacity: 0.3 })
            );
        })
    }

    private addWrz(companyName, company, layergroup, style) {
        let $ = getjQuery();
        $.getJSON(company, data => {

            let layer = L.geoJSON(data, {
                style: feature => {
                    style.fillColor = this.ragColour[this.wrzRagStatus[feature.properties.WRZAREASHO]]
                        || this.ragColour['none'];
                    return style;
                },
                onEachFeature: (feature, layer) => {
                    layer.bindTooltip(`Resource Zone<br/>
                            ${feature.properties.WRZAREANAM} <br />
                               ${this.updateResouceZoneAnnotation(feature.properties.WRZAREASHO)}`,
                        { permanent: false, opacity: 0.7 });
                    layer.on({
                        mouseover: this.highlightFeature,
                        mouseout: (e) => {
                            var layer = e.target;
                            if (!this.isSelected(layer)) {
                                layer.setStyle(style);
                            }

                        },
                        click: (e) => {
                            this.zoomToFeature(e);
                            this.displayGraphInfoBox(companyName, feature.properties.WRZAREASHO);

                            if (this.selectedShape) {
                                this.selectedShape.setStyle(this.featureStyle({ fillOpacity: 0.3 }));
                            }

                            this.selectedShape = e.target;
                            this.selectedShape.setStyle({ weight: 4, color: 'white', fillOpacity: 0.9 });

                            UsageStatsService.LogStat({ Type: UsageStats.WaterResourceZone, SubType: feature.properties.WRZAREANAM });
                        }
                    });
                }
            });
            layergroup.addLayer(layer);
        });
    }

    private displayGraphInfoBox(companyName, wrzCode: string) {
        let $ = getjQuery();
        var infoDiv = this.infoBox.getContainer();

        this.currentResourceZone = tryFirst(this.wrzData, x => x.WrzAreaShortName == wrzCode);

        if (!this.currentResourceZone) {
            $(infoDiv).addClass('hidden');
            return;
        }

        $(infoDiv).removeClass('hidden');
        $("#graph-title").text(`${companyName}, ${this.currentResourceZone.WrzName} `);
        $("#supply-balance-dry").addClass("active");
        $("#supply-balance-critical").removeClass("active");
        this.drawGraph(this.currentResourceZone.SupplyBalance);
        var organisation = getLookup("OrganisationLookup");
        var waterCompany: OrganisationRow = tryFirst(organisation.items, x => x["Id"] == this.currentResourceZone.WaterCompany);

        if (waterCompany.MarketInformationEmailAddress === undefined) {
            $("#getInTouch").addClass("hidden");
        }
        else {
            $("#getInTouch").removeClass("hidden");
        }
    }

    private updateResouceZoneAnnotation(resourceShortName: string) {
        var resource = tryFirst(this.wrzData, x => x.WrzAreaShortName == resourceShortName);
        if (!resource) return '';
        if (!resource.Annotation) return '';
        return '<div class="wrz-popup-annotation">' + resource.Annotation + '</div>';
    }
}
